import styled from 'styled-components';

const Thead = styled.td`
  color: ${(props) => (props.color ? props.color : '#000')};
  font-weight: 900;
  font-size: 26px;
  line-height: 1em;
  padding: 20px 10px;
  text-align: center;
  text-transform: uppercase;
`;
const TheadSub = styled.td`
  font-style: normal;
  font-weight: 900;
  font-size: 1.35rem;
  line-height: 1.2em;
  text-align: center;
  color: #404040;
  text-transform: uppercase;
  background: #fff;
  padding: 10px;
  border: 1px solid #eaeaea;
  border-radius: 4px 0px 0px 0px;
`;

const TInfoIndex = styled.td`
  font-style: normal;
  font-weight: 600;
  font-size: 1.2rem;
  line-height: 1.2em;
  color: #404040;
  padding: 10px;
  border: 1px solid #eaeaea;
  border-radius: 4px 0px 0px 0px;
`;

const TInfo = styled.td`
  text-align: center;
  font-style: normal;
  color: ${(props) => (props.color ? props.color : '#000')};
  font-weight: 600;
  font-size: 1.2rem;
  line-height: 1.2em;
  padding: 10px;
  border: 1px solid #eaeaea;
  border-radius: 4px 0px 0px 0px;
`;

const TColumn = styled.tr`
  width: 100%;
`;
const TColumnWithBorder = styled.tr`
  width: 100%;
  padding: 10px;
  border: 1px solid #eaeaea;
  border-radius: 4px 0px 0px 0px;
`;

const TBody = styled.tbody`
  width: 100%;
  margin-top: 1em;
  background: #ffffff;
`;

const TAction = styled.div`
  display: flex;
  width: 100%;
  padding: 10px 20px;
  align-content: center;
  justify-content: space-between;
`;

const TTextAction = styled.h3`
  font-style: normal;
  font-weight: 700;
  font-size: 26px;
  line-height: 36px;
  color: #125c5b;
  margin: 0;
`;

const CButtonContainer = styled.div`
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const TButton = styled.button`
  background-color: transparent;
  border: none;
  margin-left: 0.75rem;
  margin-right: 0.75rem;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;
  letter-spacing: 0.1px;
  cursor: pointer;
  & img {
    margin-right: 5px;
  }
`;

const CTitle = styled.h3`
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  display: block;
  letter-spacing: 0.1px;
  color: #404040;
  text-align: center;
  margin-bottom: 1.5rem;
  margin-top: 0.5rem;
`;

const CContainer = styled.div`
  padding: 1rem;
  width: 100%;
`;

const CTable = styled.table`
  box-shadow: 0px 0px 5px rgba(18, 92, 91, 0.3);
  border-radius: 25px;
  background: #ffffff;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  width: 100%;
  margin-bottom: 2em;
`;

const Closed = {
  Container: CContainer,
  Default: CTable,
  Head: Thead,
  SubHead: TheadSub,
  TInfo: TInfoIndex,
  Column: TColumn,
  ColumnBorder: TColumnWithBorder,
  Body: TBody,
  Info: TInfo,
  Action: TAction,
  TextAction: TTextAction,
  ButtonContainer: CButtonContainer,
  Button: TButton,
  Title: CTitle,
};

export default Closed;
